import { render, staticRenderFns } from "./disclaimer.vue?vue&type=template&id=55956fc0"
import script from "./disclaimer.vue?vue&type=script&lang=ts"
export * from "./disclaimer.vue?vue&type=script&lang=ts"
import style0 from "./disclaimer.vue?vue&type=style&index=0&id=55956fc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports